import styled from 'styled-components';
import variables from '@styles/variables';

export const StyledTakeoverInnerWrapper = styled.div`
  display: flex;
  z-index: ${variables.zIndex.modal + 1};
`;
